import { NodeTypes } from "@/workflow_api/types/workflow";
import { RESTRICTED_NODE_TYPES } from "./types";

export const NODE_TYPE_CATEGORIES = {
  OPERATORS: {
    title: "Operadores",
    types: [
      { value: NodeTypes.IF, label: "Condicional" },
      { value: NodeTypes.SWITCH, label: "Switch" },
      { value: NodeTypes.MULTITHREAD, label: "Multihilos" },
      { value: NodeTypes.WAIT, label: "Wait" },
      { value: NodeTypes.MERGE, label: "Merge" },
    ],
  },
  ACTIONS: {
    title: "Acciones",
    types: [
      { value: NodeTypes.ASSIGN_GROUP, label: "Asignar grupo" },
      { value: NodeTypes.NOTIFICATION, label: "Notificación" },
      { value: NodeTypes.EXPEDIENTE, label: "Expediente" },
      { value: NodeTypes.FORM, label: "Formulario" },
      { value: NodeTypes.CORRECTION, label: "Revisión" },
    ],
  },
  DATA_TRANSFORM: {
    title: "Transformación de datos",
    types: [
      { value: NodeTypes.CALCULATED, label: "Campo calculado" },
      { value: NodeTypes.DATA_CENTER, label: "Centro de datos" },
    ],
  },
  INTEGRATIONS: {
    title: "Integraciones",
    types: [
      { value: NodeTypes.PAYMENT, label: "Pasarela de pago" },
      { value: NodeTypes.N8N, label: "Objeto N8N" },
      { value: NodeTypes.INTEROPERABILITY, label: "Interoperabilidad" },
    ],
  },
  DOCUMENTS: {
    title: "Documentos",
    types: [
      { value: NodeTypes.DOC_GENERATOR, label: "Generador de documentos" },
      { value: NodeTypes.SIGN_DOCUMENT, label: "Firma digital" },
      { value: NodeTypes.RESOLUTION, label: "Resolución de trámites" },
    ],
  },
} as const;

export const getAllowedNodeTypes = () => {
  const allTypes: Array<{ value: string; label: string }> = [];

  Object.values(NODE_TYPE_CATEGORIES).forEach((category) => {
    category.types.forEach((type) => {
      if (
        !RESTRICTED_NODE_TYPES.includes(
          type.value as (typeof RESTRICTED_NODE_TYPES)[number],
        )
      ) {
        allTypes.push(type);
      }
    });
  });

  return allTypes;
};

export const getNodeTypeLabel = (nodeType: string): string => {
  for (const category of Object.values(NODE_TYPE_CATEGORIES)) {
    const found = category.types.find((type) => type.value === nodeType);
    if (found) return found.label;
  }
  return nodeType;
};
